<script>
export default {
  name: "SuccessorListAll",
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      loading: true,
      error: "",
      searchBy: "first_name",
      searchKeyword: "",
      page: 1,
      perPage: 10,
      totalPages: 1,
      from: 0,
      to: 0,
      total: 0,
      rows: [],
      debounceTimer: null,
      composerQuery: "",
      composerStatus: "",
      composerOpen: false,
      composerLoading: false,
      composerRows: [],
      selectedComposer: {
        member_code: "",
        first_name: "",
        writer_type: "",
      },
      composerTimer: null,
    };
  },
  computed: {
    formAction: function () {
      var base = String((this.config && this.config.basePath) || "");
      return (base === "" ? "" : base) + "/main-manage-member.php";
    },
    canAdd: function () {
      if (!this.config || typeof this.config.canAdd === "undefined") {
        return true;
      }
      return !!this.config.canAdd;
    },
    searchPlaceholder: function () {
      if (this.searchBy === "member_code") {
        return "รหัสผู้มีสิทธิ (ทายาท)";
      }
      if (this.searchBy === "internal_no") {
        return "Internal No.";
      }
      if (this.searchBy === "ipi_name_no") {
        return "IPI Name No.";
      }
      return "ชื่อผู้มีสิทธิ (ทายาท)";
    },
    metaText: function () {
      if (this.loading) {
        return "กำลังโหลดข้อมูล...";
      }
      if (this.error) {
        return this.error;
      }
      return "หน้า " + this.page + " / " + this.totalPages;
    },
    pageInfoText: function () {
      if (this.loading || this.error) {
        return "-";
      }
      return "แสดง " + this.from + "-" + this.to + " จากทั้งหมด " + this.total + " รายการ";
    },
    pageNumbers: function () {
      var start = Math.max(1, this.page - 2);
      var end = Math.min(this.totalPages, start + 4);
      var nums = [];
      var i;
      for (i = start; i <= end; i++) {
        nums.push(i);
      }
      return nums;
    },
  },
  mounted: function () {
    var self = this;
    this._onDocClick = function (event) {
      var wrap = self.$refs.composerWrap;
      if (wrap && wrap.contains(event.target)) {
        return;
      }
      self.composerOpen = false;
    };
    document.addEventListener("click", this._onDocClick);
    this.loadMembers(1);
  },
  beforeUnmount: function () {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    if (this.composerTimer) {
      clearTimeout(this.composerTimer);
    }
    if (this._onDocClick) {
      document.removeEventListener("click", this._onDocClick);
    }
  },
  methods: {
    safeCell: function (value) {
      var text = String(value || "").trim();
      return text === "" ? "-" : text;
    },
    initialOf: function (name) {
      var text = String(name || "").trim();
      return text ? text.charAt(0).toUpperCase() : "S";
    },
    profileHref: function (code) {
      var base = String(
        (this.config && this.config.profileBase) ||
          "main-manage-member.php?page=view_profile_successor&member_code="
      );
      return base + encodeURIComponent(String(code || "").trim());
    },
    buildListParams: function () {
      var params = new URLSearchParams();
      var keyword = String(this.searchKeyword || "").trim();
      params.set("page", String(this.page));
      params.set("per_page", String(this.perPage === 25 || this.perPage === 50 ? this.perPage : 10));
      params.set("internal_no", this.searchBy === "internal_no" ? keyword : "");
      params.set("ipi_name_no", this.searchBy === "ipi_name_no" ? keyword : "");
      params.set("member_code", this.searchBy === "member_code" ? keyword : "");
      params.set("first_name", this.searchBy === "first_name" ? keyword : "");
      params.set("rightsholder_type", "ทายาท");
      return params;
    },
    loadMembers: function (page) {
      var self = this;
      var apiUrl = String((this.config && this.config.apiUrl) || "").trim();
      this.page = Math.max(1, Number(page || 1));
      this.perPage = this.perPage === 25 || this.perPage === 50 ? this.perPage : 10;
      this.loading = true;
      this.error = "";
      if (apiUrl === "") {
        this.loading = false;
        this.error = "ไม่พบที่อยู่ API ของรายการทายาท";
        return;
      }
      fetch(apiUrl + "?" + this.buildListParams().toString(), {
        method: "GET",
        headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" },
        credentials: "same-origin",
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (!data || data.success !== true) {
            throw new Error(data && data.message ? data.message : "ไม่สามารถโหลดข้อมูลได้");
          }
          self.rows = Array.isArray(data.rows) ? data.rows : [];
          self.page = Number(data.page || 1);
          self.totalPages = Math.max(1, Number(data.total_pages || 1));
          self.from = Number(data.from || 0);
          self.to = Number(data.to || 0);
          self.total = Number(data.total || 0);
          var pp = Number(data.per_page);
          if (!isNaN(pp) && (pp === 10 || pp === 25 || pp === 50)) {
            self.perPage = pp;
          }
          self.loading = false;
        })
        .catch(function (err) {
          self.loading = false;
          self.rows = [];
          self.error = err && err.message ? err.message : "เกิดข้อผิดพลาด";
        });
    },
    debounceLoad: function () {
      var self = this;
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(function () {
        self.loadMembers(1);
      }, 280);
    },
    onFilterChange: function () {
      this.loadMembers(1);
    },
    onPerPageChange: function () {
      var v = Number(this.perPage);
      this.perPage = v === 25 || v === 50 ? v : 10;
      this.loadMembers(1);
    },
    clearFilters: function () {
      this.searchBy = "first_name";
      this.searchKeyword = "";
      this.perPage = 10;
      this.loadMembers(1);
    },
    openProfile: function (code) {
      var c = String(code || "").trim();
      if (c) {
        window.location.href = this.profileHref(c);
      }
    },
    onComposerInput: function () {
      var self = this;
      var q = String(this.composerQuery || "").trim();
      if (this.composerTimer) {
        clearTimeout(this.composerTimer);
      }
      this.composerTimer = setTimeout(function () {
        self.searchComposer(q);
      }, 300);
    },
    searchComposer: function (keyword) {
      var self = this;
      var apiUrl = String((this.config && this.config.apiUrl) || "").trim();
      if (keyword.length < 2) {
        this.composerOpen = false;
        this.composerRows = [];
        this.composerStatus = "";
        this.composerLoading = false;
        return;
      }
      this.composerLoading = true;
      this.composerStatus = "กำลังค้นหา...";
      var params = new URLSearchParams();
      params.set("page", "1");
      params.set("per_page", "10");
      params.set("first_name", keyword);
      params.set("rightsholder_type", "นักแต่งเพลง");
      fetch(apiUrl + "?" + params.toString(), {
        method: "GET",
        headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" },
        credentials: "same-origin",
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (!data || data.success !== true) {
            throw new Error("ค้นหาไม่สำเร็จ");
          }
          self.composerRows = Array.isArray(data.rows) ? data.rows : [];
          self.composerOpen = true;
          self.composerLoading = false;
          if (self.composerRows.length === 0) {
            self.composerStatus = "ไม่พบข้อมูล";
            return;
          }
          self.composerStatus = "พบ " + self.composerRows.length + " รายการ";
        })
        .catch(function () {
          self.composerOpen = false;
          self.composerLoading = false;
          self.composerStatus = "เกิดข้อผิดพลาดในการค้นหา";
        });
    },
    pickComposer: function (row) {
      this.selectedComposer = {
        member_code: String((row && row.member_code) || ""),
        first_name: String((row && row.first_name) || ""),
        writer_type: String((row && row.writer_type) || ""),
      };
      this.composerQuery = "";
      this.composerOpen = false;
      this.composerRows = [];
      this.composerStatus = "เลือกรายการแล้ว";
    },
    onOpenForm: function (event) {
      if (String(this.selectedComposer.member_code || "").trim() === "") {
        event.preventDefault();
        this.composerStatus = "กรุณาเลือกสมาชิกนักแต่งเพลงจากผลค้นหาก่อน";
        if (this.$refs.composerSearch) {
          this.$refs.composerSearch.focus();
        }
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
          <h4 class="mb-sm-0">จัดการผู้มีสิทธิ (ทายาท)</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript:void(0);">จัดการสมาชิกนักแต่ง</a></li>
              <li class="breadcrumb-item active">จัดการผู้มีสิทธิ (ทายาท)</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div v-if="canAdd" class="card">
      <div class="card-header">
        <h4 class="card-title mb-0">Search Lite - สมาชิกนักแต่งเพลง</h4>
      </div>
      <div class="card-body">
        <form class="row g-3" method="get" :action="formAction" @submit="onOpenForm">
          <input type="hidden" name="page" value="successor_add">
          <input type="hidden" name="rightsholder_type" value="ทายาท">
          <input type="hidden" name="source_member_code" :value="selectedComposer.member_code">
          <input type="hidden" name="source_member_name" :value="selectedComposer.first_name">
          <input type="hidden" name="source_writer_type" :value="selectedComposer.writer_type">
          <div class="col-12" ref="composerWrap">
            <label class="form-label" for="composer-live-search">ค้นหาจากชื่อสมาชิกนักแต่งเพลง</label>
            <div class="position-relative">
              <input
                id="composer-live-search"
                ref="composerSearch"
                v-model="composerQuery"
                type="text"
                class="form-control"
                placeholder="พิมพ์ชื่อสมาชิกนักแต่งเพลง (อย่างน้อย 2 ตัวอักษร)"
                autocomplete="off"
                @input="onComposerInput"
                @focus="composerRows.length ? (composerOpen = true) : null"
              >
              <div
                v-show="composerOpen"
                class="list-group position-absolute w-100 mt-1 shadow-sm border rounded"
                role="listbox"
                style="z-index:1050;max-height:260px;overflow-y:auto;top:100%;left:0;"
              >
                <span v-if="composerLoading" class="list-group-item text-muted">กำลังค้นหา...</span>
                <span v-else-if="composerRows.length === 0" class="list-group-item text-muted">ไม่พบข้อมูล</span>
                <template v-else>
                  <button
                    v-for="(row, idx) in composerRows"
                    :key="(row.member_code || '') + '-' + idx"
                    type="button"
                    class="list-group-item list-group-item-action text-start"
                    @click="pickComposer(row)"
                  >
                    {{ row.first_name || "-" }} ({{ row.member_code || "-" }})
                  </button>
                </template>
              </div>
            </div>
            <small class="text-muted d-block mt-1">{{ composerStatus }}</small>
          </div>
          <div class="col-xl-4">
            <label class="form-label" for="selected-composer-code">รหัสสมาชิก</label>
            <input id="selected-composer-code" type="text" class="form-control bg-light" :value="selectedComposer.member_code" readonly>
          </div>
          <div class="col-xl-5">
            <label class="form-label" for="selected-composer-name">ชื่อสมาชิกนักแต่งเพลง</label>
            <input id="selected-composer-name" type="text" class="form-control bg-light" :value="selectedComposer.first_name" readonly>
          </div>
          <div class="col-xl-3">
            <label class="form-label" for="selected-composer-writer-type">ประเภทนักแต่ง</label>
            <input id="selected-composer-writer-type" type="text" class="form-control bg-light" :value="selectedComposer.writer_type" readonly>
          </div>
          <div class="col-12 d-flex justify-content-end">
            <button type="submit" class="btn btn-primary">เปิดฟอร์มผู้มีสิทธิ (ทายาท)</button>
          </div>
        </form>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row g-3">
          <div class="col-xl-4 col-md-6">
            <label class="form-label" for="filter-search-by">ค้นหาด้วย</label>
            <select id="filter-search-by" v-model="searchBy" class="form-select" aria-label="เลือกประเภทการค้นหา" @change="onFilterChange">
              <option value="first_name">ชื่อผู้มีสิทธิ (ทายาท)</option>
              <option value="member_code">รหัสผู้มีสิทธิ (ทายาท)</option>
              <option value="internal_no">Internal No.</option>
              <option value="ipi_name_no">IPI Name No.</option>
            </select>
          </div>
          <div class="col-xl-8 col-md-6">
            <label class="form-label" for="filter-search-keyword">คำค้นหา</label>
            <input
              id="filter-search-keyword"
              v-model="searchKeyword"
              type="text"
              class="form-control"
              :placeholder="searchPlaceholder"
              @input="debounceLoad"
            >
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h4 class="card-title mb-0">Table - รายการผู้มีสิทธิ (ทายาท)</h4>
        <div class="mt-3 d-flex flex-wrap gap-3 align-items-center">
          <button type="button" class="btn btn-soft-secondary" @click="clearFilters">ล้างตัวกรอง</button>
          <span class="text-muted">{{ metaText }}</span>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive table-card mt-3 mb-1">
          <table class="table align-middle table-nowrap table-striped table-xs mb-0 table-bordered table-primary table-hover">
            <thead class="table-light">
              <tr>
                <th style="width: 5%;"></th>
                <th>รหัสผู้มีสิทธิ (ทายาท)</th>
                <th>Internal No.</th>
                <th>IPI Name No.</th>
                <th>ชื่อผู้มีสิทธิ (ทายาท)</th>
                <th>ชื่อสมาชิกนักแต่งเพลง</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="7" class="text-muted">กำลังโหลดข้อมูล...</td>
              </tr>
              <tr v-else-if="error">
                <td colspan="7" class="text-danger">โหลดข้อมูลไม่สำเร็จ</td>
              </tr>
              <tr v-else-if="rows.length === 0">
                <td colspan="7" class="text-muted">ไม่พบข้อมูลผู้มีสิทธิ (ทายาท)</td>
              </tr>
              <template v-else>
                <tr v-for="row in rows" :key="row.member_code">
                  <td>
                    <div class="avatar-xs">
                      <span class="avatar-title rounded-circle bg-primary-subtle text-primary fw-semibold">{{ initialOf(row.first_name) }}</span>
                    </div>
                  </td>
                  <td>{{ safeCell(row.member_code) }}</td>
                  <td>{{ safeCell(row.internal_no) }}</td>
                  <td>{{ safeCell(row.ipi_name_no) }}</td>
                  <td>{{ safeCell(row.first_name) }}</td>
                  <td>
                    <div v-if="String(row.source_writer_type || '').trim()" class="lh-sm">
                      <div>{{ safeCell(row.source_member_name) }}</div>
                      <div class="small text-muted">{{ String(row.source_writer_type || '').trim() }}</div>
                    </div>
                    <template v-else>{{ safeCell(row.source_member_name) }}</template>
                  </td>
                  <td>
                    <button type="button" class="btn btn-sm btn-soft-info btn-icon" title="ดูโปรไฟล์" aria-label="ดูโปรไฟล์" @click="openProfile(row.member_code)">
                      <i class="ri-eye-line fs-16"></i>
                    </button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mt-3">
          <div class="d-flex flex-wrap align-items-center gap-3">
            <small class="text-muted">{{ pageInfoText }}</small>
            <div class="d-flex align-items-center gap-2">
              <label class="form-label text-muted small mb-0" for="member-per-page">แถวต่อหน้า</label>
              <select id="member-per-page" v-model.number="perPage" class="form-select form-select-sm" style="width: 4.75rem" aria-label="จำนวนแถวต่อหน้า" @change="onPerPageChange">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
              </select>
            </div>
          </div>
          <div class="pagination-wrap hstack gap-2">
            <button type="button" class="btn btn-sm btn-light" :disabled="page <= 1" @click="loadMembers(page - 1)">Previous</button>
            <ul class="pagination listjs-pagination mb-0">
              <li v-for="n in pageNumbers" :key="n" class="page-item" :class="{ active: n === page }">
                <button type="button" class="page-link" @click="loadMembers(n)">{{ n }}</button>
              </li>
            </ul>
            <button type="button" class="btn btn-sm btn-light" :disabled="page >= totalPages" @click="loadMembers(page + 1)">Next</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
